import { useMutation } from '@tanstack/react-query';

import { type CreateVoucherPayload } from '~/services/PromoService';
import { findExistingCode } from '~/services/PromoVoucherAiService';

export function useResolvePromoAiWorkflow() {
  return useMutation({
    mutationFn: ({ name, brand }: { name: string; brand: CreateVoucherPayload['brand'] }) =>
      findExistingCode('promo', name, brand),
    retry: false,
  });
}
